module.exports = __webpack_public_path__ + "img/user.1ee2c398.svg";